import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { BlogService } from 'src/app/services/blog.service';

@Component({
  selector: 'app-archival',
  templateUrl: './archival.component.html',
  styleUrls: ['./archival.component.scss']
})
export class ArchivalComponent implements OnInit {

  constructor(
    private blogService: BlogService, 
    private router: Router, 
    private toastrService: ToastrService,
    public authService: AuthService
  ) { }
  archives:any[] = [];
  ngOnInit(): void {
    this.blogService.getBlog('archival').subscribe(
      (res:any)=>{
        this.archives = res;
      }
    )
  }

  onClickBack(){
    this.router.navigate(['blogs'])
  }

  onClickArchive(archive){
    window.open('blogPost/pdf/'+archive._id, '_blank')
  }

  getAllBlogs() {
    this.blogService.getBlog('archival').subscribe(
      (res:any)=>{
        this.archives = res;
      },
      (error) => {
        this.toastrService.error(error?.error.message || 'Something went wrong')
      }
    )
  }

  onClickDelete(blog, event) {
    this.blogService.deleteBlog(blog._id).subscribe((res: any) => {
      this.toastrService.success(res.description);
      this.getAllBlogs();
    }, (error) => {
      this.toastrService.error(error?.error.message || 'Something went wrong');
    })
    event.stopPropagation();
  }

}
